const itemCount = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '1.2857142857142858'
}

const loyaltyProductsGrid = {
  itemCount
}

export default loyaltyProductsGrid
